import {Component, OnInit} from '@angular/core';
import {CostCenter, CostCenterService} from '../cost-center.service';
import {NotificationService} from '../notification.service';
import {Router} from '@angular/router';
import {DataObjComponent, DataObjComponentHelper} from '../rest-service';
import {UserService} from '../user.service';

@Component({
  selector: 'app-cost-center',
  templateUrl: './cost-center.component.html',
  styleUrls: ['./cost-center.component.css']
})
export class CostCenterComponent implements OnInit, DataObjComponent<CostCenter> {

  readonly namePlural = 'Centros de Custo';

  readonly editPath = '/cost_centers/';

  readonly newPath = '/cost_centers_new';

  helper: DataObjComponentHelper<CostCenter>;

  constructor(private ccs: CostCenterService, private router: Router, private ns: NotificationService,
              private us: UserService) {
    this.helper = new DataObjComponentHelper<CostCenter>(ccs, ns, this.us, this.router, this.editPath);
  }

  ngOnInit() {
    this.helper.onInit();
  }
}





// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/cost-center/cost-center.component.ts